import React from 'react';
import { OverlayProvider } from 'react-aria';
import ThemeProvider, { ThemeProviderProps } from 'components/ThemeProvider';
import { defaultTheme } from 'theme';

export interface BlockheadProviderProps
  extends Pick<ThemeProviderProps, 'theme'> {
  children?: React.ReactNode;
}

const BlockheadProvider: React.FC<BlockheadProviderProps> = ({
  children,
  theme = defaultTheme,
}) => (
  <ThemeProvider theme={theme}>
    {/* TODO move overlay provider in case the blockhead provider gets reused */}
    <OverlayProvider>{children}</OverlayProvider>
  </ThemeProvider>
);

export default BlockheadProvider;
